import { render, staticRenderFns } from "./Tentang.vue?vue&type=template&id=3d16d7ce&scoped=true"
var script = {}
import style0 from "./Tentang.vue?vue&type=style&index=0&id=3d16d7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d16d7ce",
  null
  
)

export default component.exports